import {Grid, Radio, Typography} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import React, {useCallback} from 'react'

import {PaymentSystemIcon} from '../payment-system-icon'
import {classes} from './PaymentCard.classes'
import {PaymentCardItemProps, PaymentCardProps} from './PaymentCard.types'

const PaymentCardItemMobile = React.memo<PaymentCardItemProps>(
  ({expirationDate, isChecked, system, number, onPress}) => {
    return (
      <Grid direction="column" container item>
        <Grid alignItems="center" onPointerUp={onPress} wrap="nowrap" container item>
          <PaymentSystemIcon className={classes.logo} paymentSystem={system} mobile />
          <Grid direction="column" container item xs>
            <Typography Component={Grid} variant="body2" item>
              {`${system} ··· ${number.substring(number.length - 4)}`}
            </Typography>
            {expirationDate && (
              <Typography Component={Grid} variant="caption1" item>
                {expirationDate}
              </Typography>
            )}
          </Grid>
          <Grid item>
            <Radio checked={isChecked} />
          </Grid>
        </Grid>
      </Grid>
    )
  },
)

const PaymentCardItemDesktop = React.memo<PaymentCardItemProps>(
  ({number, expirationDate, system, onPress, className, isChecked = false}) => {
    return (
      <Grid
        alignItems="flex-start"
        className={clsx(classes.root, className)}
        data-e2e="payment-card"
        direction="column"
        justify="space-between"
        onPointerUp={onPress}
        wrap="wrap"
        container
      >
        <Grid alignItems="center" className={classes.row} justify="space-between" container item xs>
          <Grid item xs>
            <PaymentSystemIcon paymentSystem={system} />
          </Grid>
          <Grid item>
            <Radio checked={isChecked} className={classes.radio} />
          </Grid>
        </Grid>
        <Grid className={classes.row} direction="column" container item xs>
          <Typography Component={Grid} thickness="light" variant="title4" item>
            {number}
          </Typography>
          {expirationDate && (
            <Grid className={classes.date} item>
              {expirationDate}
            </Grid>
          )}
        </Grid>
      </Grid>
    )
  },
)

const PaymentCard: React.FC<PaymentCardProps> = ({card, onPress, isChecked = false, isMobile = false}) => {
  const clickHandler = useCallback(() => {
    onPress?.(card)
  }, [card, onPress])

  const className = clsx({
    [classes.checked]: isChecked,
    [classes.hovered]: onPress,
  })

  return isMobile ? (
    <PaymentCardItemMobile {...card} className={className} isChecked={isChecked} onPress={clickHandler} />
  ) : (
    <PaymentCardItemDesktop {...card} className={className} isChecked={isChecked} onPress={clickHandler} />
  )
}

PaymentCard.displayName = 'PaymentCard'

export default React.memo(PaymentCard)
